<template>
    <div class="fSize">
        <!--第二张图片-->
        <van-cell class="newCell">
            <van-image fit="contain" width="100%" height="100%" :src="detail.imageurl2"/>
        </van-cell>
        <!--购买信息-->
        <van-cell class="newCell">
            <van-row>
                <van-col span="24" class="text">
                    <span class="text card-type">{{detail.type === 'combo'?'套餐':detail.type === 'value_card'?'储值卡':'代金券'}}</span>
                    <span style="margin-left:0.12rem">{{detail.name }}</span>
                </van-col>
            </van-row>
            <van-row>
                <van-col span="9">
                    <van-col style="color:red;font-size:0.4rem">{{'￥'+(detail.price/100)}}</van-col>
                    <van-col style="text-decoration:line-through;color:#bfbfbf;margin-left:0.24rem">
                        {{'￥'+(detail.orgPrice/100)}}
                    </van-col>
                </van-col>
                <van-col span="9" class="text" style="color:#bfbfbf;font-size:0.24rem;">
                    {{'已售'+detail.saleCount+'单'}}
                </van-col>
            </van-row>
            <van-row>
                <van-col span="24">{{detail.text1}}</van-col>
            </van-row>
        </van-cell>
        <van-cell-group v-if="detail.imageurl3" class="marBottom">
            <van-cell title="套餐简介" class="fontWE"/>
            <!--<van-cell v-if="detail.imageurl2" class="newCell">
                <van-image fit="contain" width="100%" height="100%" :src="detail.imageurl2"/>
            </van-cell>-->
            <van-cell v-if="detail.text2" :value="'\u3000\u3000'+detail.text2"/>
            <van-cell v-if="detail.imageurl3" class="newCell">
                <van-image fit="contain" width="100%" height="100%" :src="detail.imageurl3"/>
            </van-cell>
            <van-cell v-if="detail.text3" :value="'\u3000\u3000'+detail.text3"/>
        </van-cell-group>
        <van-cell-group v-else class="marBottom">
            <van-cell title="套餐简介" class="fontWE"/>
            <van-cell :value="'\u3000\u3000'+detail.text2+detail.text3"/>
        </van-cell-group>
        <van-cell class="buttonFixed" safe-area-inset-bottom>
            <van-button size="normal" round block type="info" @click="goOrder">立即购买</van-button>
        </van-cell>
        <van-action-sheet safe-area-inset-bottom :round="false" v-model="showBase" title="订单与支付">
            <OrderAndBuy @fatherMethod="closeChild" :item="detailData"></OrderAndBuy>
        </van-action-sheet>
    </div>
</template>
<script>
    import OrderAndBuy from "@/components/OrderAndBuy";
    import {
        Button, Cell, ActionSheet, Image as VanImage, Swipe, SwipeItem, Col, Row, Toast, Dialog, CellGroup
    } from "vant";
    import {getSetMeal} from "@/api/common";

    export default {
        components: {
            [Button.name]: Button, [Cell.name]: Cell, [ActionSheet.name]: ActionSheet, OrderAndBuy,
            [VanImage.name]: VanImage, [Swipe.name]: Swipe, [SwipeItem.name]: SwipeItem, [Col.name]: Col,
            [Row.name]: Row, [CellGroup.name]: CellGroup
        },
        data() {
            return {
                detail: {},
                id: null,
                detailData: {},
                showBase: false //立即购买显示
            };
        },
        created() {
            const that = this;
            that.id = that.$route.query.id ? that.$route.query.id : that.id;
            this.getData(that.id);
        },
        methods: {
            //页面数据查询
            getData(id) {
                const that = this;
                Toast.loading({
                    message: "数据加载中...",
                    forbidClick: true,
                    loadingType: "spinner",
                    duration: 0
                });
                getSetMeal({openId: sessionStorage.getItem("openid"), id: id}, 1).then(resp => {
                    that.detail = resp.code === 200 && resp.data ? resp.data : {};
                    Toast.clear();
                    if (!that.detail) {
                        //为空处理
                        Dialog.alert({
                            message: "套餐信息不存在..."
                        }).then(() => {
                            that.$router.push({path: "/buyCard"});
                        });
                    }
                }).catch(err => {
                    console.log(err);
                });
            },
            //去购买页面
            goOrder() {
                const that = this;
                if (sessionStorage.getItem("userIsBang") === "yes") {
                    //传递子组件数据//展示子组件
                    that.detailData = JSON.stringify(that.detail);
                    //传递子组件数据//展示子组件
                    that.showBase = true;
                } else {
                    //如果用户信息为空则去设置用户
                    Dialog.alert({
                        message: "用户信息为空无法进行下一步操作，去添加"
                    }).then(() => {
                        that.$router.push({path: "/userAdd"});
                    });
                    return false;
                }
            },
            //关闭子组件窗口
            closeChild() {
                const that = this;
                that.showBase = false;
                that.detailData = null;
            }
        }
    };
</script>
<style scoped>
    .newCell {
        margin: 0.16rem 0;
    }

    .newCol {
        font-size: 0.32rem;
        color: #ee0a24;
        font-weight: 700;
    }

    .fontWE {
        font-weight: 700;
    }

    .marBottom {
        margin-bottom: 1.32rem;
    }

    .text {
        font-size: 0.28rem;
        text-align: left;
        font-weight: 700;
        /* padding-left: 0.26rem; */
    }

    .card-type {
        color: #bfbfbf;
        font-size: 0.24rem;
        /* max-width: 0.95rem; */
        background: #f5f5f5;
        border-radius: 0.15rem;
        padding: 0.06rem 0.12rem;
    }
</style>
